// extracted by mini-css-extract-plugin
export var deleteModal = "_qi-0";